// extracted by mini-css-extract-plugin
export default {"container":"Trim_container__cAFNa","productListContainer":"Trim_productListContainer__edwH9","productGrid":"Trim_productGrid__SxI3I"};